import React from 'react';

/**
 * "← cutthe6.com home" at the top of an auth card, for visitors who reached
 * sign-in / sign-up / start-listing from the public site. Renders nothing
 * without a handler, so the card looks as before wherever it's not wired.
 *
 * @param {object} props
 * @param {() => void} [props.onHome]
 */
export default function AuthHomeLink({ onHome }) {
  if (!onHome) return null;
  return (
    <a
      href="/"
      className="auth-home-link"
      onClick={(event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        onHome();
      }}
    >
      <span aria-hidden="true">←</span> cutthe6.com home
    </a>
  );
}
